export default "__VITE_ASSET__CnuWgb4j__"